var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
// require('bootstrap');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');
// require('bootstrap-material-design');

import Headroom from "headroom.js";
require('jquery-sticky');
// require('jquery-match-height');

require('owl.carousel');
require('magnific-popup');
// require('jquery-match-height');
// require('lazysizes');
// require('picturefill');
const WOW = require('wow.js');
// require('@fortawesome/fontawesome-free');


// var elements = document.querySelectorAll('input,select,textarea');

// for (var i = elements.length; i--;) {
//     elements[i].addEventListener('invalid', function () {
//         this.scrollIntoView(false);
//     });
// }

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    if ($('.headroom-header').length) {
        var Header = document.querySelector('#header');
        var headroom = new Headroom(Header, {
        "offset": 205,
        "tolerance": 15
        });
        headroom.init();
    }

    //wow.js animations
    new WOW().init({});

    $('#btn-mob-nav, #mob-nav .close-modal, #home-mob-reg').on('click', function() {
        $('#mob-nav').fadeToggle('slow');
        $('#btn-mob-nav .open-menu').toggleClass('d-block');
        $('#btn-mob-nav .close-menu').toggleClass('d-none');
        $('#header').toggleClass('mob-menu-fixed-top');
    });

    //add class to body tag - to style 3D Tour modal
    $('.btn-tour').on('click', function() {
        $('body').addClass('tour-panel');
    });


    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    $('.selectpicker').selectpicker();

    $('bootstrap-select.show').on('keydown', function(e) {
        if (e.keyCode == 38) { // Up
            var previousEle = $(this).prev();
            if (previousEle.length == 0) {
                previousEle = $(this).nextAll().last();
            }
            var selVal = $('.selectpicker option').filter(function() {
                return $(this).text() == previousEle.text();
            }).val();
            $('.selectpicker').selectpicker('val', selVal);

            return;
        }
        if (e.keyCode == 40) { // Down
            var nextEle = $(this).next();
            if (nextEle.length == 0) {
                nextEle = $(this).prevAll().last();
            }
            var selVal = $('.selectpicker option').filter(function() {
                return $(this).text() == nextEle.text();
            }).val();
            $('.selectpicker').selectpicker('val', selVal);

            return;
        }
    });

     if ($('.pop-image').length) {
        $('body').addClass('single-image');

        $('.pop-image').magnificPopup({
            type: 'image',
            gallery: {
                enabled: false
            },

        });
    }

      if ($('.pop-youtube, .pop-inline').length) {
        $('body').addClass('youtube-modal');

        $('.pop-youtube, .pop-inline').magnificPopup({
            gallery: {
                enabled: true
            },
            callbacks: {
                elementParse: function(item) {
                    // Set type based on element class
                    if (item.el) {
                        var $el = $(item.el);
                        if ($el.hasClass('pop-inline')) {
                            item.type = 'inline';
                        } else if ($el.hasClass('pop-youtube')) {
                            item.type = 'iframe';
                        }
                    }
                },
                beforeChange: function() {
                    // Set type before content changes during navigation
                    if (this.currItem && this.currItem.el) {
                        var $el = $(this.currItem.el);
                        if ($el.hasClass('pop-inline')) {
                            this.currItem.type = 'inline';
                        } else if ($el.hasClass('pop-youtube')) {
                            this.currItem.type = 'iframe';
                        }
                    }
                },
                open: function() {
                    // Ensure video poster shows when first opened
                    if (this.currItem && this.currItem.type === 'inline') {
                        var self = this;
                        setTimeout(function() {
                            var video = self.content.find('video')[0];
                            if (video) {
                                video.pause();
                                video.currentTime = 0;
                                video.load();
                            }
                        }, 10);
                    }
                },
                change: function() {
                    // Reset inline videos when navigating to show poster
                    if (this.currItem && this.currItem.type === 'inline') {
                        var self = this;
                        setTimeout(function() {
                            var video = self.content.find('video')[0];
                            if (video) {
                                video.pause();
                                video.currentTime = 0;
                                video.load();
                            }
                        }, 50);
                    }
                },
                buildControls: function() {
                    if (this.arrowLeft && this.arrowRight) {
                        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                    }
                },
                close: function() {
                    // Stop videos when modal closes
                    this.content.find('video').each(function() {
                        this.pause();
                        this.currentTime = 0;
                    });
                    this.content.find('iframe').each(function() {
                        this.src = '';
                    });
                },
            },
        });
    }

    if ($('.pop-video').length) {
        $('body').addClass('hero-video');

        $('.pop-video').magnificPopup({
            type: 'iframe',
            // gallery: {
            //     enabled: false
            // },
            iframe: {
               patterns: {
                   youtube: {
                       index: 'youtube.com',
                       id: 'v=',
                       src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
                    }
               }
           },
           callbacks: {
                open: function() {
                    var bgVideo = document.getElementById('bgVideo');
                    if (bgVideo && !bgVideo.paused) {
                            bgVideo.pause();
                        }else{
                    }
                },
                close: function() {
                    var bgVideo = document.getElementById('bgVideo');

                    if (bgVideo) {
                        if ($(bgVideo).hasClass('playing')) {
                            // Play the background video if the video has the class 'playing'
                            bgVideo.play();
                        }
                    }
                }
            }
        });
    }

    if ($('#bgVideo').length) {

    var video = document.getElementById("bgVideo");

        $('#btn-pause').on('click', function() {
            video.pause();
            $(this).addClass('d-none').removeClass('d-flex');
            $("#btn-play").addClass('d-flex').removeClass('d-none');
            $(video).removeClass('playing');
        });

        $('#btn-play').on('click', function() {
            video.play();
            $(this).addClass('d-none').removeClass('d-flex');
            $("#btn-pause").addClass('d-flex').removeClass('d-none');
            $(video).addClass('playing');
        });

        $('#btn-mute').on('click', function() {
            $(video).prop('muted', true);
            $(this).addClass('d-none').removeClass('d-flex');
            $("#btn-volume").addClass('d-flex').removeClass('d-none');
        });

        $('#btn-volume').on('click', function() {
            $(video).prop('muted', false);
            $(this).addClass('d-none').removeClass('d-flex');
            $("#btn-mute").addClass('d-flex').removeClass('d-none');
        });

    };

    // $('.datepicker').datetimepicker({
    //     format: 'DD/MM/YYYY',
    //     showTodayButton: true,
    //     showClear: true
    // });

    $('.modal--register').on('shown.bs.modal', function() {
        $('#name').trigger('focus')
    })


    // placeholder polyfill for browsers that need it
    // $('input, textarea').placeholder();

    if ($('.iframe-gallery').length) {
        $('.iframe-gallery').each(function() {
            $(this).magnificPopup({
                delegate: '.iframe-link',
                type: 'iframe',
                tLoading: 'Loading image #%curr%...',
                // mainClass: 'mfp-img-mobile mfp-figure',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
                },
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                        '<div class="mfp-close"></div>' +
                        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                        '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

                    patterns: {
                        youtube: {
                            index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
                            id: 'v=', // String that splits URL in a two parts, second part should be %id%
                            // Or null - full URL will be returned
                            // Or a function that should return %id%, for example:
                            // id: function(url) { return 'parsed id'; }
                            src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
                        },
                        vimeo: {
                            index: 'vimeo.com/',
                            id: '/',
                            src: '//player.vimeo.com/video/%id%?autoplay=1'
                        },
                        gmaps: {
                            index: '//maps.google.',
                            src: '%id%&output=embed'
                        }

                        // you may add here more sources

                    },

                    srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
                }


            });
        })
    }


    if ($('.popup-gallery').length) {
        $('.popup-gallery').each(function() {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                tLoading: 'Loading image #%curr%...',
                mainClass: 'mfp-img-mobile mfp-figure',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
                },
                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function(item) {
                        return item.el.attr('title');
                    }
                },
                zoom: {
                    enabled: true, // By default it's false, so don't forget to enable it

                    duration: 300, // duration of the effect, in milliseconds
                    easing: 'ease-in-out', // CSS transition easing function

                    // The "opener" function should return the element from which popup will be zoomed in
                    // and to which popup will be scaled down
                    // By defailt it looks for an image tag:
                    opener: function(openerElement) {
                        // openerElement is the element on which popup was initialized, in this case its <a> tag
                        // you don't need to add "opener" option if this code matches your needs, it's defailt one.
                        return openerElement.is('img') ? openerElement : openerElement.find('img');
                    }
                },
                callbacks: {
                    beforeOpen: function() {
                        // just a hack that adds mfp-anim class to markup
                        this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
                        this.st.mainClass = this.st.el.attr('data-effect');
                    },
                    buildControls: function() {
                        // re-appends controls inside the main container
                        // this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                    },
                    change: function() {
                    $(this.content).find('.mfp-title').each(function(idx, elm) {
                        console.log(elm);

                        if (elm.innerText) {
                            $(elm).removeClass('d-none');
                        } else {
                            $(elm).addClass('d-none');
                        }
                    });
                }
                }
            });
        })
    }

    // initPopupFiles();

    if ($('#slider-values').length) {
        $('#slider-values').owlCarousel({
            responsiveRefreshRate: 1,
            loop: false,
            margin: 5,
            responsiveClass: true,
            items: 1,
            nav: true,
            navText: [""],
            dots: false,
            dotsEach: true,
            autoplay: false,
            autoplayTimeout: 1000,
            smartSpeed: 750

        })
    }



    // $('.scrollup').on('click', function() {
    //     $("html, body").animate({
    //         scrollTop: 0
    //     }, 600);
    //     return false;
    // });


    if ($('.down-scroll').length) {
        // Page scroll
        $('.down-scroll').bind('click', function(event) {
            var $anchor = $(this);

            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top - 104
            }, 500, 'easeInOutExpo');

            event.preventDefault();
        });
    }

    $('#villageTab a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
        history.replaceState(null, null, e.target.href);
    })

    if (window.location.hash) {
        $('#villageTab a[data-toggle="tab"]').removeClass('active');
        $('#villageTabContent .tab-pane-resources').removeClass('active');

        $(`[href="${window.location.hash}"]`).addClass('active');
        $(window.location.hash).tab('show');
    }

    scrollToFormError();

    // $(window).scroll(function() {
    //     if ($(this).scrollTop() > 125) {
    //         $('#main-nav').addClass('page-down');
    //     } else {
    //         $('#main-nav').removeClass('page-down');
    //     }
    // });



    $(window).on('load', function() {
        initFlipbook();
    });
});

// scroll window to form error element and offset fixed header height
function scrollToFormError() {
    // console.log('scrollToFormError', window.location.hash);
    var windowWidth = $(window).width();
    var formStr = '#form-';
    // enquiry form error anchor offset
    if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {

        var formEl = window.location.hash;
        if ($(formEl).length > 0) {

            // var offsetSize = $('.headerfixed').height();
            // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());
            setTimeout(() => {
                var offsetSize = $('.navbar--main').height() + 300;
                if (windowWidth > 767) {
                    // offset
                    // animate scrollto
                    $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
                } else {
                    $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
                }
            }, 500)

        }
    }
}

window.initPopupFiles = initPopupFiles;

function initPopupFiles() {
    if ($('.popup-files').length) {
        $('.popup-files').magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                markup: '<div class="mfp-figure popup-files">' +
                    '<div class="mfp-close"></div>' +
                    '<a class="mfp-download"></a>' +
                    '<div class="mfp-img"></div>' +
                    '</div>' +
                    '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button

                cursor: 'mfp-zoom-out-cur', // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.

                //                titleSrc: 'title', // Attribute of the target element that contains caption for the slide.
                // Or the function that should return the title. For example:
                // titleSrc: function(item) {
                //   return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
                // }

                verticalFit: true, // Fits image in area vertically

                tError: '<a href="%url%">The image</a> could not be loaded.' // Error message
            },
            callbacks: {
                buildControls: function() {
                    // re-appends controls inside the main container
                    this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                },
                change: function() {
                    $(this.content).find('.mfp-title').each(function(idx, elm) {
                        console.log(elm);

                        if (elm.innerText) {
                            $(elm).removeClass('d-none');
                        } else {
                            $(elm).addClass('d-none');
                        }
                    });
                }
            }
        });
    }
}

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Infinite Ajax Scroll
}

function initFlipbook() {
    if ($('#flipbook').length > 0) {

        var pdf = $('#flipbook').data('src');
        var pdf_options = {
            webgl: true,
            height: "auto",
            // height: 750,
            enableDownload: false,
            scrollWheel: false,
            hideControls: 'share'
        };
        var flipBook = $("#flipbook").flipBook(pdf, pdf_options);

        $('#brochure-tab').on('shown.bs.tab', function(e) {
            // fix hidden tab init issue
            flipBook.resize();
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js